export default __webpack_public_path__ + "static/media/88.8786210f.png";